require('./brokerTransferPensionPlansExternalView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;

// @Components
const BrokerTransferPensionPlansExternal = require("components/broker/brokerTransferPensionPlansExternal/brokerTransferPensionPlansExternal");
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');

// @Constants
const {
    MYPROFILE_BROKER_URL,
    BROKER_INVESTMENT_SPECIALIST_EMAIL
} = require('constants/index');

//@Actions
const brokerTransferPensionPlansExternalActions = require('actions/brokerTransferPensionPlansExternal');
const brokerAdvancedSearchExploreActions = require('actions/brokerAdvancedSearch');
const specialistsActions = require('actions/investmentSpecialists');

/**
* Shows Pension Plans transfer wizard
* URL: /myprofile/broker/pensions/transfer/External
*/
class BrokerTransferPensionPlansExternalView extends React.Component {

    constructor(props) {
        super(props);

        this.onAmountChange = this.onAmountChange.bind(this);
        this.onAccountChange = this.onAccountChange.bind(this);
        this.onDestinationPlanChange = this.onDestinationPlanChange.bind(this);
        this.onHandleDestinationPlans = this.onHandleDestinationPlans.bind(this);
        this.onDestinationOptionChange = this.onDestinationOptionChange.bind(this);
        this.onFiscalizationOptionChange = this.onFiscalizationOptionChange.bind(this);
        this.onChangePlanFromSearch = this.onChangePlanFromSearch.bind(this);
        this.onTransferTypeChange = this.onTransferTypeChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const {
            immAccounts,
            immBrokerMyInvestments,
            immBrokerJointContracts,
            requestAllPensionPlans
        } = this.props;
        const immPlans = immBrokerMyInvestments.getIn(['products', 'plans', 'stocks']);
        requestAllPensionPlans(immPlans, immAccounts, immBrokerJointContracts);
    }

    componentWillUnmount() {
        const { resetExternalTransfer } = this.props;
        resetExternalTransfer();
    }

    onAmountChange(value) {
        const { changeAmountInput } = this.props;
        changeAmountInput(value);
    }

    onChangePlanFromSearch(producto) {
        const {
            onSetPlanSelectedFromSearch,
        } = this.props;

        onSetPlanSelectedFromSearch(producto);
    }

    onDestinationPlanChange(planId) {
        const {
            immBrokerJointContracts,
            immBrokerTransferPensionPlansExternal,
            onSetDestinationPlan
        } = this.props;

        const immPlans = immBrokerTransferPensionPlansExternal.get('walletPlansData');

        onSetDestinationPlan(planId, immPlans, immBrokerJointContracts);
    }

    onAccountChange(accountId) {
        const {
            onSetAccount
        } = this.props;

        onSetAccount(accountId);
    }


    onDestinationOptionChange(option) {
        const { changeDestinationOption } = this.props;
        changeDestinationOption(option);
    }

    onTransferTypeChange(option) {
        const { changeTransferTypeOption } = this.props;
        changeTransferTypeOption(option);
    }

    onFiscalizationOptionChange(option) {
        const { changeFiscalizationOption } = this.props;
        changeFiscalizationOption(option);
    }

    onHandleDestinationPlans() {
        const { setDestinationPlans } = this.props;
        setDestinationPlans();
    }

    handleCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    handleFinish() {
        const { ExternalTransferConf } = this.props;
        ExternalTransferConf();
    }

    buildHeader() {
        const subTitle = formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_externalTransferSubtitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('breadcrumb-breadcrumb_bringPlansToOpenBank'),
            }
        ];

        return (
            <div className="row">
                <OKCover size="medium" section="broker">
                    <BrokerTruncatedBreadcrumb
                        titleKey="brokerMyInvestmentsMoreOptions-brokerMyInvestmentsMoreOptions_bringPlansToOpenBank"
                        subtitleLeft={subTitle}
                        breadcrumbConfig={mappingBreadcrumb}
                    >
                    </BrokerTruncatedBreadcrumb>
                </OKCover>
            </div>
        );
    }

    buildBody() {
        const {
            attachFile,
            changeFileDescription,
            removeFileAttached,
            immAccounts,
            immBrokerTransferPensionPlansExternal,
            immInvestmentSpecialists,
            immBrokerMyInvestments,
            immProfile,
            reset,
            setAmountRange,
            setVisibleStep,
            setWillCancel,
            setWillLeave,
            toggleDisclaimer,
            validateStep,
            onCallTimeChange,
            onCommentChange,
            onRequestBrokerCallTimeOptions,
            onRequestCall,
            onToggleModal,
            getSpecialists,
            titleKey,
            email,
            context,
            requestCallFn,
            onSetProfilePhone,
            onReset,
            onTelCodeChange,
            onTelChange
        } = this.props;

        const immPlans = immBrokerTransferPensionPlansExternal.get('walletPlansData');
        let bodyContent;
        let brokerError = immBrokerMyInvestments.get('errorReceived');

        if(immBrokerTransferPensionPlansExternal.get('isFetching')) {
            bodyContent = <LoadingSection />
        } else {
            bodyContent = (
                <div className="col-xs-12">
                    <BrokerTransferPensionPlansExternal
                        brokerError={brokerError}
                        handleAmountChange={this.onAmountChange}
                        handleDestinationPlans={this.onHandleDestinationPlans}
                        handleOriginPlanChange={this.onOriginPlanChange}
                        handleDestinationPlanChange={this.onDestinationPlanChange}
                        handleChangeDestinationOption={this.onDestinationOptionChange}
                        handleChangeTransferTypeOption={this.onTransferTypeChange}
                        handleInputSearchPlanSelected={this.onChangePlanFromSearch}
                        handleRemoveFile={removeFileAttached}
                        handleSetDescription={changeFileDescription}
                        handleAttachFile={attachFile}
                        handleChangeFiscalizationOption={this.onFiscalizationOptionChange}
                        handleAccountChange={this.onAccountChange}
                        immAccounts={immAccounts}
                        immBrokerTransferPensionPlansExternal={immBrokerTransferPensionPlansExternal}
                        immInvestmentSpecialists={immInvestmentSpecialists}
                        immPlans={immPlans}
                        immProfile={immProfile}
                        onCancel={this.handleCancel}
                        onFinish={this.handleFinish}
                        reset={reset}
                        setAmountRange={setAmountRange}
                        setVisibleStep={setVisibleStep}
                        setWillCancel={setWillCancel}
                        setWillLeave={setWillLeave}
                        toggleDisclaimer={toggleDisclaimer}
                        validateStep={validateStep}
                        onTelCodeChange={onTelCodeChange}
                        onTelChange={onTelChange}
                        onCallTimeChange={onCallTimeChange}
                        onCommentChange={onCommentChange}
                        onToggleModal={onToggleModal}
                        onRequestBrokerCallTimeOptions={onRequestBrokerCallTimeOptions}
                        onRequestCall={onRequestCall}
                        getSpecialists={getSpecialists}
                        titleKey={titleKey}
                        email={email}
                        context={context}
                        requestCallFn={requestCallFn}
                        onSetProfilePhone={onSetProfilePhone}
                        onReset={onReset}
                        />
                </div>
            )
        }

        return (
            <div className="container-fluid">
                <div className="row grid-view--content-position-negative">
                    {bodyContent}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className="container-fluid">
                    {this.buildHeader()}
                </div>
                <div className="grid-view__body">
                    {this.buildBody()}
                </div>
            </div>
        )
    }
}

BrokerTransferPensionPlansExternalView.propTypes = {
    attachFile: PropTypes.func.isRequired,
    changeAmountInput: PropTypes.func.isRequired,
    changeDestinationOption: PropTypes.func.isRequired,
    changeTransferTypeOption: PropTypes.func.isRequired,
    changeFiscalizationOption: PropTypes.func.isRequired,
    setDestinationPlans: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired,
    immBrokerJointContracts: PropTypes.object.isRequired,
    immBrokerTransferPensionPlansExternal: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immInvestmentSpecialists: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    ExternalTransferConf: PropTypes.func.isRequired,
    onSetPlanSelectedFromSearch: PropTypes.func.isRequired,
    onSetAccount: PropTypes.func.isRequired,
    onSetDestinationPlan: PropTypes.func.isRequired,
    requestAllPensionPlans: PropTypes.func.isRequired,
    resetExternalTransfer: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setAmountRange: PropTypes.func.isRequired,
    setAccountChange: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setWillLeave: PropTypes.func.isRequired,
    toggleDisclaimer: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onTelCodeChange: PropTypes.func.isRequired,
    onTelChange: PropTypes.func.isRequired,
    onCallTimeChange: PropTypes.func.isRequired,
    onCommentChange: PropTypes.func.isRequired,
    onRequestCall: PropTypes.func.isRequired,
    onRequestBrokerCallTimeOptions: PropTypes.func.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    getSpecialists: PropTypes.func,
    changeFileDescription: PropTypes.func.isRequired,
    removeFileAttached: PropTypes.func.isRequired,
    titleKey: PropTypes.string,
    email: PropTypes.string,
    context: PropTypes.string,
    requestCallFn: PropTypes.func,
    onSetProfilePhone: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
}

BrokerTransferPensionPlansExternalView.defaultProps = {
    titleKey: 'broker-investmentSpecialist',
    email: BROKER_INVESTMENT_SPECIALIST_EMAIL,
    context: 'general'
};


module.exports.constructor = BrokerTransferPensionPlansExternalView;
module.exports.BrokerTransferPensionPlansExternalView = connect(state => ({
    immAccounts: state.accounts,
    immProfile: state.profile,
    immBrokerJointContracts: state.brokerJointContracts,
    immBrokerMyInvestments: state.brokerMyInvestments,
    immPensionPlan: state.brokerPensionPlans,
    immInvestmentSpecialists: state.brokerInvestmentSpecialists,
    immBrokerTransferPensionPlansExternal: state.brokerTransferPensionPlansExternal
}), {
    attachFile: brokerTransferPensionPlansExternalActions.attachFile,
    changeFileDescription: brokerTransferPensionPlansExternalActions.changeFileDescription,
    changeAmountInput: brokerTransferPensionPlansExternalActions.changeAmountInput,
    changeDestinationOption: brokerTransferPensionPlansExternalActions.changeDestinationOption,
    changeTransferTypeOption: brokerTransferPensionPlansExternalActions.changeTransferTypeOption,
    changeFiscalizationOption: brokerTransferPensionPlansExternalActions.changeFiscalizationOption,
    setDestinationPlans: brokerTransferPensionPlansExternalActions.setDestinationPlans,
    ExternalTransferConf: brokerTransferPensionPlansExternalActions.externalTransferConf,
    onSetAccount: brokerTransferPensionPlansExternalActions.onSetAccount,
    onSetPlanSelectedFromSearch: brokerTransferPensionPlansExternalActions.onSetPlanSelectedFromSearch,
    onSetDestinationPlan: brokerTransferPensionPlansExternalActions.onSetDestinationPlan,
    requestAllPensionPlans: brokerTransferPensionPlansExternalActions.requestAllPensionPlans,
    resetExternalTransfer: brokerTransferPensionPlansExternalActions.reset,
    removeFileAttached: brokerTransferPensionPlansExternalActions.removeFileAttached,
    resetBrowser: brokerAdvancedSearchExploreActions.reset,
    setAmountRange: brokerTransferPensionPlansExternalActions.setAmountRange,
    setAccountChange: brokerTransferPensionPlansExternalActions.onSetAccount,
    setVisibleStep: brokerTransferPensionPlansExternalActions.setVisibleStep,
    setWillCancel: brokerTransferPensionPlansExternalActions.setWillCancel,
    setWillLeave: brokerTransferPensionPlansExternalActions.setWillLeave,
    toggleDisclaimer: brokerTransferPensionPlansExternalActions.toggleDisclaimer,
    validateStep: brokerTransferPensionPlansExternalActions.validateStep,
    getSpecialists: specialistsActions.getSpecialists,
    onCallTimeChange: specialistsActions.changeCallTime,
    onCommentChange: specialistsActions.changeComment,
    onRequestBrokerCallTimeOptions: specialistsActions.requestBrokerCallTimeOptions,
    onRequestCall: specialistsActions.requestCall,
    onTelChange: specialistsActions.changeTel,
    onTelCodeChange: specialistsActions.changeTelCode,
    onToggleModal: specialistsActions.toggleModal,
    onSetProfilePhone: specialistsActions.setProfilePhone,
    onReset: specialistsActions.reset
})(withRouter(BrokerTransferPensionPlansExternalView));


